import {API_ENDPOINTS, LoadingKeys} from '@/constants';
import {INotificationCreatePayload, INotificationListItem, ListResponse,} from '@/models';
import {changeEnabledStatus, http} from '@/utils';
import {handleApiCallInStore, updateItemById} from './utils';

import {AxiosRequestConfig} from 'axios';
import {create} from 'zustand';
import {persist} from 'zustand/middleware';
import {t} from 'i18next';

export interface INotificationsStore {
  notificationsList: INotificationListItem[];
  nbHits: number;
  getNotificationsList: (params) => void;
  changeDiscountCodeStatus: (payload: {
    objectID: string;
    isActive: boolean;
  }) => void;
  createNotification: (
    payload: INotificationCreatePayload,
    onSuccess: () => void
  ) => void;
}

export const useNotificationsStore = create(
  persist<INotificationsStore>(
    set => ({
      notificationsList: [],
      learnerLogs: [],
      nbHits: 0,
      getNotificationsList: async params => {
        handleApiCallInStore(LoadingKeys.GetNotificationsList, async () => {
          const {data} = await http.get<ListResponse<INotificationListItem>>(
            API_ENDPOINTS.notifications,
            {params} as AxiosRequestConfig
          );
          const {items, nbHits} = data;
          set(() => ({notificationsList: items ?? [], nbHits}));
        });
      },
      changeDiscountCodeStatus: payload => {
        handleApiCallInStore(LoadingKeys.ChangeNotificationStatus, async () => {
          const {isActive, objectID} = payload;
          await http.put(`${API_ENDPOINTS.notifications}/${objectID}/change`, {
            objectID,
            isActive,
          });

          set(({notificationsList}) => ({
            notificationsList: updateItemById(
              notificationsList,
              'isActive',
              isActive,
              objectID
            ),
          }));

          changeEnabledStatus(isActive, t('notification'));
        });
      },
      createNotification: (payload, onSuccess) => {
        handleApiCallInStore(LoadingKeys.CreateNotification, async () => {
          await http.post(`${API_ENDPOINTS.notifications}`, payload);
          await onSuccess();
        });
      },
    }),
    {
      name: 'notifications-storage',

    }
  )
);
